import { render, staticRenderFns } from "./addEditGoods.vue?vue&type=template&id=63f6ad92"
import script from "./addEditGoods.vue?vue&type=script&lang=js"
export * from "./addEditGoods.vue?vue&type=script&lang=js"
import style0 from "./addEditGoods.vue?vue&type=style&index=0&id=63f6ad92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports